<!--
 - Author : wanghongling.
 - Date   : 2019/8/8.
 - File   : test.测试页
 -->

<template>
  <div class="testWrap">
    <img class="dragImg" src="../assets/images/test/testBg.jpg" ref="img" alt="" @mousedown="imgDrag">
  </div>
</template>

<script>
  export default {
    data () {
      return {
        msg: 'hello vue compoent!'
      }
    },
    methods: {
      /**
       * 图片拖拽
       * @author wanghongling
       * @createTime 2019/08/08
       */
      imgDrag(e) {
        let IMG = e.target
        IMG.style.cursor = 'pointer'
        // 阻止默认事件的方法,如果不阻止默认事件onmouseup会无法触发
        e.preventDefault()
        // 算出鼠标相对元素的位置
        let disX = e.clientX - IMG.offsetLeft
        let disY = e.clientY - IMG.offsetTop
        document.onmousemove = e => {
          console.log('移动')
          // 鼠标按下并移动的事件
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          // 因为img居中对齐，所以还要减去目标元素距离body的偏移量
          let left = e.clientX - disX
          let top = e.clientY - disY
          // 移动当前元素
          IMG.style.left = left + 'px'
          IMG.style.top = top + 'px'
        }
        document.onmouseup = () => {
          console.log('停止')
          document.onmousemove = null
          document.onmouseup = null
          IMG.style.cursor = 'inherit'
        }
        return false
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .testWrap{
    position: absolute;
    width: 1920px;
    height: 1080px;
    overflow: hidden;
    left: 0;
    top: 0;
    .dragImg{
      position: absolute;
      left: 0;
      top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/test.vue